import { useCallback, useEffect, useState } from 'react';
import {
  getTeacherClassManagementSetting,
  TeacherClassManagementSetting,
} from '../api/requests/settings';

export default function useTeacherClassManagementSetting() {
  const [data, setData] = useState<TeacherClassManagementSetting | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const { data, error } = await getTeacherClassManagementSetting();

    if (error) setError(true);
    setData(data ?? null);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
